

const { delegate } = require('./helpers');
import Core from 'hvx/modules/CoreModule';
import KCService from 'kcservice';
import Inbox from './inbox';
import Details from './details';
import Popup from './popup';
import WebSocketConnection from 'websocket';
import NotificationStore from './store';
import { templates } from './notification-item';
// get current url domain from browser location


import {
  init,
  classModule,
  propsModule,
  styleModule,
  datasetModule,
  eventListenersModule,
  h,
  attributesModule,
} from 'snabbdom';

const patch = init([
  classModule,
  propsModule,
  styleModule,
  attributesModule,
  datasetModule,
  eventListenersModule,
]);
class Notification {
  constructor() {


    if (Notification._instance) {
      return Notification._instance;
    }
    Notification._instance = this;
    // TODO: this should have it's own class
    this.notifications = new NotificationStore('notifications');
    
    // init inbox
    this.timeouts = {};
    this.useLocalTime = true;
    this.templates = templates;
    this.inbox = new Inbox(this.notifications);
    this.details = new Details(this.notifications);
    this.notify_popup_container_elm = document.querySelector('.notify-popup-container') || (() => {
      const elem = document.createElement('div');
      elem.classList.add('notify-popup-container');
      document.body.appendChild(elem);
      return elem;
    })();
    this.socket_instnce = null;
    this.vnode = null;
    this._bindEvents();
    this.notifications.addEventListener('load', () => {
      // console.log('load');
      this.render();
    });
    this.notifications.addEventListener('save', () => {
      
      this.render();
    });
    this.notifications.load();
    this._pendingSubscriptions = [];

    const keycloak = new KCService().getToken();
    if (keycloak && keycloak.token) {
      this.initWebSocket();
    } else {
      Core.EventManager.addListener('hvx.user.authenticated', () => {
        this.initWebSocket();
      });
    }
  }

  initWebSocket() {
    if (this.socket_instnce) {
      return;
    }
    // create a new websocket connection
    // get current url domain
    let ws_url = '';
    // eslint-disable-next-line no-undef
    ws_url = ENVS_NOTIFICATION_WS_URL;

    const keycloak = new KCService().getToken();
    const accessToken = keycloak && keycloak.token;
    if (accessToken) {
      const socketUrl = new URL(ws_url, window.location.origin);
      socketUrl.searchParams.set('access_token', accessToken);
      ws_url = socketUrl.toString();
    }

    console.log('Connecting to websocket at:', accessToken ? ws_url.replace(accessToken, '[redacted]') : ws_url);

    const socket = new WebSocketConnection(ws_url);
    const messages = socket.getMessages();
    this.socket_instnce = socket;
    messages.subscribe(
      (msg) => {
        // if message topic is 'iweb.HVX.storm.update` raise and event to update the storm
        this.socket_instnce.lastMessage = msg;
        if(msg.type === 'ping') {
          this.socket_instnce.lastMessage = 'ping';
          return;
        }
        if (msg.topic === 'iweb.HVX.storm.update') {
          Core.EventManager.fireEvent('iweb.HVX.storm.update', JSON.parse(msg.message));
          return;
          // if message topic start with 'jobID' raise and event to update the storm
        } if (msg.topic === 'iweb.HVX.ww.update') {
          Core.EventManager.fireEvent('iweb.HVX.ww.update', JSON.parse(msg.message));
          return;
        }
        else if (msg.topic.startsWith('jobID')){
          Core.EventManager.fireEvent('iweb.HVX.stormsim.complete', JSON.parse(msg.message));
          return;
        } 
        // when a message is received, log it
        // console.log(msg);
        this.push({...msg
        });
      },
      (err) => {
        // if there is an error, log it
        console.log('error', err);
      },
      () => {
        // if the connection closes,
        console.log('connection closed');
      },
    );
    socket.subscribe('iweb.HVX.storm.update');
    socket.subscribe('iweb.HVX.notification');

    if (this._pendingSubscriptions && this._pendingSubscriptions.length > 0) {
      this._pendingSubscriptions.forEach((sub) => socket.subscribe(sub));
      this._pendingSubscriptions = [];
    }
  }
  popupEvent(event, selector, handler, ...args) {
    delegate(this.notify_popup_container_elm, selector, event, (e) => {
      
      const $el = e.target.closest('[data-id]');
      
      handler(this.notifications.get($el.dataset.id), e, $el,...args );
    
    });
  }

  _bindEvents() {
    this.popupEvent('click', '.countdown', this.toggleTimeout.bind(this),false);
    this.popupEvent('click', '.notify-popup-close', this.togglePopup.bind(this),false);
    this.popupEvent('click', '.notify-action-close', (...args) => {
      this.togglePopup(...args,false);
      this.remove(...args);
    } 
    );  
  }
  /**
   * 
   * push is used to add new elements to the array
   * @param {import ('./notification-item').NotificationStoreItem} notification 
   */
  push(notification) {
    if (this.notifications.exists({
      message: notification.message,
      title: notification.title}) && !notification.notInbox) 
      return;
    const n = this.notifications.add(notification);
    if (n && n.time > 0) {
      this.timeouts[n.id] =  window.setTimeout((() => {
        this.togglePopup(n,false);
      }).bind(this), n.time);
    }
    Core.EventManager.fireEvent('hvx.notification.hasunread', !notification.notInbox);
  }

  // shift is used to extract items from the array
  /**
   * 
   * @param {EventTarget} e 
   * @param {Popup} popup 
   * @param {Object} notification 
   */
  remove(notification) {
    // e.target.closest('.notify-popup').remove();
    this.notifications.remove(notification);
    if(this.timeouts[notification.id]!==undefined){

      clearTimeout(this.timeouts[notification.id]);
    }
  }
  // subscribe to websocket topic
  subscribe(topic) {
    if (this.socket_instnce) {
      this.socket_instnce.subscribe(topic);
    } else {
      this._pendingSubscriptions = this._pendingSubscriptions || [];
      this._pendingSubscriptions.push(topic);
    }
  }

  hasUnread() {
    return this.notifications.hasUnread();
  }

  toggleDetached(notification){
    Core.EventManager.fireEvent('hvx.notification.detials', false);

    this.notifications.toggleDetached(notification);
  }

  togglePopup(notification, e, $el, to) {
    // console.log('togglePopup', notification, to);
    this.notifications.togglePopup(notification,to);
    if (typeof notification.onClose === 'function') {
      notification.onClose(notification);
    }
    if (notification.notInbox) {
      this.remove(notification);
    }
  }
  // eslint-disable-next-line no-unused-vars
  toggleTimeout(notification, e, $el, to) {
    // console.log('timeout', notification, to);
    clearTimeout(this.timeouts[notification.id]);
    
    // TODO 
    this.notifications.toggleTimeout(notification, 0);
  }


  shift() {
    return this.notifications.shift();
  }
  render() {
    const Cnode = h('div.notify-popup-container', {}, this.notifications.all('popup').map((n) => Popup.render(n, {useLocalTime: this.useLocalTime,
      store: this.notifications,
      toggleActive:this.toggleDetached.bind(this) },this.toggleTimeout.bind(this))));
    if (this.vnode === null) {
      this.vnode = patch(this.notify_popup_container_elm, Cnode);
    } else {
      this.vnode = patch(this.vnode, Cnode);
    }
  }

}

export default Notification;